import { useContext } from 'react';

import { useTranslation } from 'react-i18next';
import { useMutation } from 'react-query';

import { WelletContext } from '../../../context/wellet/welletContext';
import { Show } from '../../../components';
import { Button, Modal, Toast } from '../../../uiComponents/common';
import { deleteReservationProduct } from '../../../services';

const ModalDeleteProduct = ({ callback, open, setOpen, reservationId, id }) => {
  const welletContext = useContext(WelletContext);
  const { t } = useTranslation('translation', { keyPrefix: 'modals.deleteProduct' });
  // API Queries
  const deleteProductMutation = useMutation({
    mutationFn: () => {
      return deleteReservationProduct(welletContext, reservationId, id);
    },
    onSuccess: () => {
      callback();
    },
  });

  // Functions
  const handleModal = () => {
    setOpen(null);
  };

  const handleClose = () => {
    handleModal();
    deleteProductMutation.reset();
  };

  return (
    <>
      <Show.When isTrue={deleteProductMutation.isSuccess}>
        <Toast
          message={t('toast.success')}
          type={`SUCCESS`}
          onCallback={() => {
            handleClose();
          }}
        />
      </Show.When>
      <Show.When isTrue={deleteProductMutation.isError}>
        <Toast message={t('toast.error')} type={`ERROR`} onCallback={handleClose} />
      </Show.When>
      <Show.When isTrue={open !== null}>
        <Modal
          title={t('title')}
          open={open !== null}
          onClose={handleClose}
          maxWidth='450px'
          closeIcon={true}
          closeOnDocumentClick={false}
          customButtons={
            <>
              <div className='d-flex justify-content-end'>
                <Button
                  text={t('cancel')}
                  disabled={!deleteProductMutation.isIdle}
                  className={' btn-general btn-wellet-secondary'}
                  size={'medium'}
                  onClick={handleModal}
                />
                <Button
                  text={t('submit')}
                  disabled={!deleteProductMutation.isIdle}
                  className={' ml-2 btn-general btn-wellet-primary'}
                  size={'medium'}
                  onClick={() => deleteProductMutation.mutate()}
                />
              </div>
            </>
          }
        >
          <div className='text-left mt-2 mb-3 fw-500'>{t('ask')}</div>
        </Modal>
      </Show.When>
    </>
  );
};

export default ModalDeleteProduct;
